<template>
  <div class="login">
    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      label-position="right"
      label-width="120px"
      class="demo-ruleForm"
    >
      <div class="box">
        <div class="box-text">
          <span>{{ $t('main.login') }}</span>
        </div>
        <div class="flex-box">
          <div
              class="flex-item"
              :class="{ active: isPsw }"
              @click="changeLoginWay('psw')"
          >
            <i class="el-icon-lock"
            ><span style="margin-left: 6px;">{{
                $t('main.passwordLogin')
              }}</span></i
            >
          </div>
          <div
              class="flex-item"
              v-if="isCN"
              :class="{ active: !isPsw }"
              @click="changeLoginWay('other')"
          >
            <i class="el-icon-mobile-phone">
              <span style="margin-left: 6px;">{{ $t('main.telephoneLogin') }}</span>
            </i>
          </div>
          <div
              class="flex-item"
              v-if="!isCN"
              :class="{ active: !isPsw }"
              @click="changeLoginWay('other')"
          >
            <i class="el-icon-mobile-phone">
                <span style="margin-left: 6px;">{{
                    $t('main.emailLogin')
                  }}</span>
            </i>
          </div>
        </div>
        <!-- 密码登录 -->
        <div v-if="isPsw">
          <!-- 账户 -->
          <el-form-item class="is-required" :label="$t('main.account') + ':'" prop="account">
            <el-input
              v-model="formData.account"
              :placeholder="$t('main.enterMailPhone')"
            ></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item class="is-required" :label="$t('main.password')+':'" prop="password">
            <el-col :span="14">
              <el-input
                  show-password
                  v-model="formData.password"
                  :placeholder="$t('main.pleaseEnterYourPassword')"
              ></el-input>
            </el-col>
            <el-button
                @click="forgetpsw"
                class="sendCode"
            >
              <div>{{ $t('main.forgetPassword') }}</div>
            </el-button>
          </el-form-item>
          <!-- 验证码 -->
          <el-row>
            <el-col :span="18">
              <el-form-item class="is-required" :label="$t('main.Captcha')+':'" prop="code">
                <el-input
                  v-model="formData.code"
                  :placeholder="$t('main.pleaseEnterYourCaptcha')"
                  @keyup.enter.native="login"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div class="login-code">
                <img
                    :src="codeUrl"
                    @click="getCode"
                    style="width: 100px;height: 3.75rem;"
                />
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 手机登录 -->
        <div v-if="!isPsw && isCN">
          <!-- 手机号 -->
          <el-form-item class="is-required" :label="$t('main.telephoneAccount')" prop="telephone">
            <el-input
              v-model="formData.telephone"
              :placeholder="$t('main.enterTelephone')"
            ></el-input>
          </el-form-item>
          <!-- 验证码 -->
          <el-row>
            <el-form-item class="is-required" :label="$t('main.loginCode')+':'" prop="captcha">
              <el-col :span="15">
                <el-input
                  v-model="formData.captcha"
                  :placeholder="$t('main.pleaseEnterYourLoginCode')"
                ></el-input>
              </el-col>
              <el-col :span="5">
                <el-button
                  @click="sendCode"
                  class="sendCode"
                  :disabled="countdown > 0"
                >
                  <div v-if="countdown > 0">{{ countdown }} s</div>
                  <div v-else>{{ $t('main.sendLoginCode') }}</div>
                </el-button>
              </el-col>
            </el-form-item>
          </el-row>
        </div>
        <!-- 邮箱登录 -->
        <div v-if="!isPsw && !isCN">
          <!-- 邮箱 -->
          <el-form-item class="is-required" :label="$t('main.emailAccount')+':'" prop="email">
            <el-input
                v-model="formData.email"
                :placeholder="$t('main.enterMail')"
            ></el-input>
          </el-form-item>
          <!-- 验证码 -->
          <el-row>
            <el-form-item class="is-required" :label="$t('main.loginCode')+':'" prop="captcha">
              <el-col>
                <el-input
                    v-model="formData.captcha"
                    :placeholder="$t('main.pleaseEnterYourLoginCode')"
                ></el-input>
              </el-col>
              <el-button
                  @click="sendCode"
                  class="sendCode"
                  :disabled="countdown > 0"
              >
                <div v-if="countdown > 0">{{ countdown }} s</div>
                <div v-else>{{ $t('main.sendLoginCode') }}</div>
              </el-button>
            </el-form-item>
          </el-row>
        </div>
        <!-- 密码登录 -- 记住密码 -->
        <div class="leftcheck" v-if="isPsw">
          <el-checkbox v-model="checked">{{ $t('main.rememberMe') }}</el-checkbox>
        </div>
        <el-button class="loginBtn loginBtnForGoogle" @click="login">{{
          $t('main.login')
        }}</el-button>
        <div class="right">
          {{ $t('main.noAccount') }}
          <span class="gzc" @click="goToRegister">
            {{ $t('main.Registration') }}
          </span>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { login, getCodeCaptcha, smslogin } from '@/api/login'
import { sendSMS, sendEmail } from '@/api/index'
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      formData: {
        account: '',
        password: '',
        code: '', // 验证码
        telephone: '', // 短信登录 - 手机号
        email: '', // 邮箱登录 - 邮箱
        captcha: '', // 短信登录 - 验证码
      },
      rules: {
        name: [
          // { required: true, message: "请输入活动名称", trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
      },
      checked: false,
      codeUrl: '',
      isPsw: true, // 中文 - true ：密码登录  false：短信登录
      isCN: true, // 是否中文
      countdown: 0, //发送验证码倒计时
    }
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.isCN = this.$i18n.locale === "zn";
      }
    }
  },
  mounted() {
    this.userLanguage();
    this.getCode();
  },
  methods: {
    getCode() {
      getCodeCaptcha(50).then((res) => {
        if (res.rsp.code === 0) {
          this.codeUrl = res.data.captcha;
        }
      });
    },
    // 切换登录方式
    changeLoginWay(val) {
      this.isPsw = val === 'psw' ? true : false
    },
    // 判断是否中文
    userLanguage() {
      this.isCN = this.$i18n.locale === "zn";
    },
    login() {
      this.isPsw ? this.handlerPswLogin() : this.hanlerSmsLogin()
    },
    // 密码登录
    handlerPswLogin() {
      login(
        this.formData.account,
        this.formData.password,
        this.formData.code,
        ''
      ).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          })
          this.$store.dispatch('setUserinfo', res.data)
          //根据从哪个界面进到登录界面，然后跳转到之前页面
          if (this.$route.params.frompath) {
            this.$router.push(this.$route.params.frompath)
          } else {
            this.$router.push({
              path: this.redirect || '/userCenter',
            })
          }
        } else {
          this.getCode()
          this.$message({
            message: res.rsp.msg,
            type: 'error',
          })
        }
      })
    },

    // 短信密码登录
    hanlerSmsLogin() {
      let params = {
        req: {
          username: this.isCN ? this.formData.telephone : this.formData.email,
          captcha: this.formData.captcha,
        },
      }
      smslogin(params).then((res) => {
        // console.log("登录成功后返回",res);
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          })
          this.$store.dispatch('setUserinfo', res.data)
          //根据从哪个界面进到登录界面，然后跳转到之前页面
          if (this.$route.params.frompath) {
            this.$router.push(this.$route.params.frompath)
          } else {
            this.$router.push({
              path: this.redirect || '/',
            })
          }
        } else {
          this.getCode()
          this.$message({
            message: res.rsp.msg,
            type: 'error',
          })
        }
      })
    },
    startCountdown() {
      if (this.countdown > 0) {
        this.countdown--
        setTimeout(() => {
          this.startCountdown()
        }, 1000)
      }
    },
    //发送验证码
    sendCode() {
      let data = {}
      if (this.isCN) {
        data = {
          req: {
            telephone: this.formData.telephone,
          },
        }
        sendSMS(data).then((res) => {
          if (res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: "success"
            })
            this.countdown = 60
            this.startCountdown()
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error',
            })
          }
        })
      } else {
        data = {
          req: {
            email: this.formData.email,
          },
        }
        sendEmail(data).then((res) => {
          if (res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: "success"
            })
            this.countdown = 60
            this.startCountdown()
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error',
            })
          }
        })
      }
    },
    getToken() {
      this.$store.dispatch('getwhUUid').then((e) => {
        if (e) {
          this.getCode()
        }
      })
    },
    goToRegister() {
      this.$router.push('/register')
    },
    forgetpsw() {
      this.$router.push({
        path: '/getpsw'
      })
    },
  },
}
</script>

<style scoped lang="less">
.gzc {
  color: #635796;
  cursor: pointer;
  margin-left: 5px;
}

.login-code {
  width: 100px;
  height: 60px;
}

.right {
  padding-top: 1.875rem;
  text-align: right;
}

.yanzhenma {
  // border:1px solid red;
  margin-left: -14px;
  margin-top: 24px;
}

.login {
  text-align: center;

  .box {
    width: 500px;
    padding: 3rem;
    margin: 3.25rem auto;
    border: 1px solid #f5f5f5;
    border-radius: 1rem;

    .box-text {
      font-size: 1.875rem;
      line-height: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: bold;
      color: #1a1a1a;
      padding-bottom: 3rem;

      span {
        position: relative;
        padding: 0 15px;
        background: #fff;
      }
    }

    .box-text:before {
      content: '';
      display: block;
      position: relative;
      width: 100%;
      height: 1px;
      top: 1rem;
      background: #f5f5f5;
    }

    .flex-box {
      display: flex;
      justify-content: space-around;
      font-weight: 500;
      margin-bottom: 1.5rem;
      padding: 0 4rem;

      .flex-item {
        cursor: pointer;
      }
      .flex-item:hover {
        color: #635796;
      }
      .active {
        color: #635796;
      }
    }

    .leftcheck {
      margin: 0 0 1.875rem 0;
      text-align: left;
    }

    .loginBtn {
      width: 100%;
      height: 3rem;
      background: #635796;
      border-radius: 1rem;
      font-weight: 500;
      color: #ffffff;
    }

    .footer {
      margin-top: 4.25rem;
      text-align: center;

      .inImg {
        width: 3.125rem;
        height: 3.125rem;
      }

      .inImg + .inImg {
        margin-left: 3.75rem;
      }
    }
  }
  /deep/ .el-form-item {
    border: 1px solid #e5e5e5;
    border-radius: 4px;

    .sendCode {
      height: 3.75rem;
      position: absolute;
      border: 0;
      right: 0;
      float: right;
      color: #1a1a1a;
      border-radius: 0.5rem;
    }
    .sendCode:hover {
      background: none;
    }
    .sendCode:focus {
      background: none;
    }
  }
  /deep/ .el-button {
    padding: 12px 5px;
  }
  /deep/ .el-input__inner {
    border: 0px solid #dcdfe6;
  }
  /deep/ .el-form-item__label {
    //padding: 0px !important;
    height: 3.75rem;
    line-height: 3.75rem;
    background-color: #fff;
    color: #1a1a1a;
    border: 0;
    font-weight: 600;
    border-radius: 0.5rem;
  }

  /deep/ .el-input__inner {
    height: 3.75rem;
    line-height: 3.75rem;
    padding: 0;
    background-color: #fff;
    border: 0;
  }

  /deep/ .el-input-group__append {
    background-color: #fff;
    color: #1a1a1a;
    border: 0;
    width: 140px;
    text-align: right;
    padding: 0;
    cursor: pointer;
  }

  /deep/ .el-input-group__prepend {
    background-color: #fff;
    color: #1a1a1a;
    border: 0;
    font-weight: 600 !important;
  }

  /deep/ .el-input-group > .el-input__inner {
    border: 0px;
    height: 3.75rem;
  }

  /deep/ .el-checkbox__label {
    color: #999999;
  }
}
</style>
